// items配列（フォルダ行/動画行混在）の型判定ヘルパー
// フォルダIDと動画IDは別採番のため、IDのみでの照合はエンティティ衝突を起こす。
// items/選択リストをIDで検索・絞り込みする箇所は必ずこのヘルパーを経由すること。

// item_type未設定は既存データ互換のためvideoとみなす
export const isFolderItem = (item) => item?.item_type === 'folder';

export const isVideoItem = (item) => !isFolderItem(item);

export const filterVideoItems = (list) =>
  (Array.isArray(list) ? list : []).filter((item) => isVideoItem(item));

export const findVideoItemById = (list, id) => {
  const normalizedId = String(id ?? '');
  if (!normalizedId) {
    return undefined;
  }
  return filterVideoItems(list).find(
    (entry) => String(entry?.id ?? '') === normalizedId
  );
};

// 選択リスト(basketMap等)の複合キー生成。フォルダIDと動画IDの衝突を防ぐ。
export const itemKey = (item) => {
  const type = isFolderItem(item) ? 'folder' : 'video';
  return `${type}:${item?.id}`;
};
